<template>
    <div>
        <div class="d-flex justify-content-end flex-wrap mb-3">
            <button
                type="button"
                class="btn btn-outline-green ml-1"
                @click="openOrderSidebar(detailedItem.order_id)"
            >
                В заказ
            </button>
            <button
                type="button"
                class="btn btn-outline-green ml-1"
                @click="openOrderSidebar(detailedItem.order_id, '', {tab: detailedItem.service.reference_service_id})"
            >
                В услугу
            </button>
        </div>

        <div class="row active-panel-block align-items-center m-0">
            <div class="active-panel-block_icon">
                <b-icon icon="grip-vertical" font-scale="2" class="text-secondary"></b-icon>
            </div>
            <div class="active-panel-block_one">
                <span class="text-bold-size-13 text-secondary">
                    <i class="fas fa-user-circle text-orange mr-1"></i> Менеджер:
                    <span class="font-weight-light">{{ detailedItem.creator.name || "Не известно" }}</span>
                </span>
            </div>
            <div class="text-bold-size-13 active-panel-block_two text-secondary">
                <span class="font-weight-bold text-uppercase"><i class="fas fa-info-circle text-orange mr-1"></i> Статус:</span>
                <span class="font-weight-light text-uppercase mr-2">
                    {{ debtInRubles() <= 0 && detailedItem.sum != 0 ? 'Оплачено' : 'Ожидает оплаты' }}
                </span>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-12">
                <b-overlay
                    :show="dataOverlay"
                    spinner-variant="success"
                    no-wrap
                />
                <table class="table table-hover table-borderless table-fixed">
                    <tbody>
                        <tr>
                            <td class="table-title-details">Номер счета</td>
                            <td>
                                <template>
                                    {{ detailedItem.invoice_number || "Не задан" }}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Дата счета</td>
                            <td>{{ (detailedItem.invoice_datetime || "Не указана") | formattedDate }}</td>
                        </tr>
                        <tr>
                            <td class="table-title-details">{{ dateRealizationBlock.blockName }}</td>
                            <td>
                                <div class="align-items-center d-flex justify-content-between">
                                    <div>{{ (detailedItem.realization_datetime || "Не указана") | formattedDate }}</div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="table-title-details">Предоставлены</td>
                            <td>
                                <div class="align-items-center d-flex justify-content-between">
                                    <template v-if="detailedItem.finance_substatuses.length > 0">
                                        <div class="table-mini-info-details shadow-orange">
                                            <div
                                                v-for="(substatus, index) in detailedItem.finance_substatuses"
                                                :key="index"
                                                class="d-flex justify-content-between align-items-center my-2"
                                            >
                                                <div>
                                                    {{ substatus.substatus_local }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        Не отмечалось
                                    </template>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Тип счета</td>
                            <td>{{ detailedItem.invoice_type_name || "Не известно" }}</td>
                        </tr>
                        <tr v-if="detailedItem.invoice_type == 'incoming'">
                            <td class="table-title-details">Плательщик</td>
                            <td>
                                <span v-if="detailedItem.order">
                                    {{ detailedItem.order.company.name }}
                                </span>
                                <span v-else>Не задана</span>
                                /
                                <span>
                                    {{ detailedItem.order.company.inn || "ИНН пока не задан" }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="detailedItem.invoice_type == 'outgoing'">
                            <td class="table-title-details">Плательщик</td>
                            <td>
                                <template v-if="detailedItem.payer_company_id">
                                    {{ detailedItem.payer_company.name }}
                                </template>
                                <template v-else>
                                    АО "ТАНАИС"
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Получатель</td>
                            <td>
                                <span v-if="detailedItem.company">
                                    {{ detailedItem.company.name }}
                                </span>
                                <span v-else>Не задана</span>
                                /
                                <span>
                                    {{ detailedItem.company.inn || "ИНН пока не задан" }}
                                </span>
                            </td>
                        </tr>
                        <template v-if="detailedItem.unit === 'B2B'">
                            <tr v-if="detailedItem.service">
                                <td class="table-title-details">Услуга</td>
                                <td>{{ detailedItem.service.reference.name || "Не указана" }}</td>
                            </tr>
                            <tr v-else>
                                <td class="table-title-details">Услуга</td>
                                <td>Не указана</td>
                            </tr>
                        </template>
                        <tr v-if="serviceProperties['247']">
                            <td class="table-title-details">Место прибытия СВХ</td>
                            <td>{{ serviceProperties['247'] }}</td>
                        </tr>
                        <tr v-if="serviceProperties['248']">
                            <td class="table-title-details">Таможенный пост</td>
                            <td>{{ serviceProperties['248'] }}</td>
                        </tr>
                        <tr v-if="detailedItem.services_list.data && detailedItem.services_list.data.length > 0">
                            <td class="table-title-details">Перечень услуг</td>
                            <td>
                                <div class="table-mini-info-details shadow-orange">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>№</th>
                                                <th>Услуга</th>
                                                <th class="text-center">Кол-во</th>
                                                <th class="text-center">Цена</th>
                                                <th class="text-center">Стоимость</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(service, index) in detailedItem.services_list.data" :key="index">
                                                <td>{{ service.id }}</td>
                                                <td>{{ service.name }}</td>
                                                <td class="text-center">{{ service.number ? service.number : 1 }}</td>
                                                <td class="text-center">{{ service.sum }}</td>
                                                <td class="text-center">{{ (Number(service.number ? service.number : 1) * service.sum) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="detailedItem.invoice_type == 'outgoing'">
                            <td class="table-title-details">Тип услуги контрагентов</td>
                            <td>
                                <template v-if="detailedItem.service_for_partner">{{ detailedItem.service_for_partner.name || "Не указана" }}</template>
                                <template v-else>Не указана</template>
                            </td>
                        </tr>
                        <tr v-if='detailedItem.invoice_type == "incoming" && detailedItem.turning != null'>
                            <td class="table-title-details">Перевыставление, %</td>
                            <td>
                                <b>{{ detailedItem.turning }} %</b><br>
                                <small>
                                    {{ countTurningSum() }}
                                </small>
                            </td>
                        </tr>
                        <template v-if="detailedItem.unit === 'B2C'">
                            <tr v-if="detailedItem.reference_terminal">
                                <td class="table-title-details">Терминал</td>
                                <td>{{ detailedItem.reference_terminal.name || "Не указан" }}</td>
                            </tr>
                            <tr v-else>
                                <td class="table-title-details">Терминал</td>
                                <td>Не указана</td>
                            </tr>
                        </template>
                        <tr>
                            <td class="table-title-details">Валюта</td>
                            <td>{{ detailedItem.currency_local.name || "Не указана" }}</td>
                        </tr>
                        <tr v-if="detailedItem.reference_currency_id != 122">
                            <td class="table-title-details">Сумма в валюте</td>
                            <td>
                                <b>{{ (detailedItem.sum_currency || 0) | toCurrency }} {{ detailedItem.currency_local.name }}</b>
                                <span class="text-danger" v-if="detailedItem.sum <= 0"> (Не забудьте указать сумму в рублях!)</span>
                            </td>
                        </tr>
                        <tr v-if="detailedItem.reference_currency_id != 122">
                            <td class="table-title-details">Оплачено в валюте</td>
                            <td><b>{{ (additionalData.paidSumCurrency || 0) | toCurrency }} {{ detailedItem.currency_local.name }}</b></td>
                        </tr>
                        <tr v-if="detailedItem.reference_currency_id != 122">
                            <td class="table-title-details">Задолженность в валюте</td>
                            <td><b :class="checkDbt()">{{ debtInCurrency() | toCurrency }} {{ detailedItem.currency_local.name }}</b></td>
                        </tr>
                        <!-- v-if="detailedItem.reference_currency_id != 122" //  при валютных платежах-->
                        <tr>
                            <td class="table-title-details">Комиссия банка</td>
                            <td>
                                <template>
                                    <b>{{ (detailedItem.commission_bank || 0) | toCurrency }} р.</b>
                                    <span class="text-danger" v-if="detailedItem.sum_payment > 0 && !detailedItem.commission_bank"> (Не забудьте указать комиссию банка в рублях!)</span>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="detailedItem.reference_currency_id != 122">
                            <td class="table-title-details">Суммовая разница</td>
                            <td><b :class="checkSumDiff()">{{ (detailedItem.sum_difference || 0) | toCurrency }} р.</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Сумма в рублях</td>
                            <td>
                                <template v-if="detailedItem.reference_currency_id == 122">
                                    <b>{{ (detailedItem.sum || 0) | toCurrency }} р.</b>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Натуральная форма?</td>
                            <td><b>{{ detailedItem.natural_text || "Не указана" }}</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Нулевая ставка</td>
                            <td><b>{{ detailedItem.zero_rate_text || "Не указана" }}</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">С НДС?</td>
                            <td><b>{{ detailedItem.with_nds_text || "Не указана" }}</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Дата финальной оплаты</td>
                            <td>{{ (detailedItem.payment_datetime || "Не указана") | formattedDate }}</td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Оплачено в рублях</td>
                            <td><b>{{ (detailedItem.sum_payment || 0) | toCurrency  }} р.</b></td>
                        </tr>
                        <tr>
                            <td class="table-title-details">Задолженность в рублях</td>
                            <td><b :class="checkDbt()">{{ debtInRubles() | toCurrency }} р.</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { API_GET_ORDERS_SERVICES_PROPERTIES_LIST } from '@/constants';
import { defaultDataItems } from '@/mixins';
import { openOrderSidebar } from '@/mixins/openOrderSidebar';

export default {
    props: {
        detailedItem: { type: Object, required: true },
        additionalData: { type: Object, required: false },
    },
    mixins: [
        defaultDataItems,
        openOrderSidebar
    ],
    data() {
        return {
            dataOverlay: false,
            serviceProperties: {
                '247': '',          // СВХ
                '248': '',          // Таможенный пост
            }
        }
    },
    computed: {
        dateRealizationBlock() {
            if (this.detailedItem.invoice_type == "outgoing") {
                return {
                    blockName: "Дата акта",
                    changeDate: "акта"
                }
            }

            return {
                blockName: "Дата реализации (по Акту)",
                changeDate: "реализации"
            }
        }
    },
    mounted() {
        this.loadServiceProperties(this.detailedItem.service.id, '247,248') // СВХ и Таможенный пост
    },
    methods: {
        debtInCurrency() {
            return (this.detailedItem.sum_currency - this.additionalData.paidSumCurrency) || 0
        },
        debtInRubles() {
            if (this.detailedItem.reference_currency_id == 122 || this.debtInCurrency() !== 0) {
                return this.detailedItem.sum - this.detailedItem.sum_payment
            }
            return 0
        },
        checkDbt() {
            if (this.debtInRubles() > 0) {
                return "text-danger"
            }
            return "text-success"
        },
        checkSumDiff() {
            if (this.detailedItem.sum_difference < 0) {
                return "text-danger"
            }
            return "text-success"
        },
        loadServiceProperties(order_service_id, reference_service_property_ids) {
            this.dataOverlay = true
            api.call("get", `${API_GET_ORDERS_SERVICES_PROPERTIES_LIST}/?order_service_id=${order_service_id}&reference_service_property_ids=${reference_service_property_ids}`)
                .then(({data}) => {
                    data.forEach((property, index) => {
                        let text = this.$store.state.referencePropertiesList.list[property.value] ? this.$store.state.referencePropertiesList.list[property.value].text : ''
                        this.serviceProperties[property.reference_service_property_id] = text
                    })
                    this.dataOverlay = false
                })
        },
        checkSubstatuses(finance_substatuses) {
            let result = [];
            finance_substatuses.forEach((substatus) => {
                result.push(substatus.substatus_local)
            })
            result.sort();
            return result;
        },
        countTurningSum() {
            let itogSum = 0;
            let valuteName = 'р.';

            if (this.detailedItem.sum_currency) {
                itogSum = this.detailedItem.sum_currency * this.detailedItem.turning / 100;
                valuteName = '$';
                if (this.detailedItem.reference_currency_id == 123) valuteName = '€';
                if (this.detailedItem.reference_currency_id == 378) valuteName = '￥';
                if (this.detailedItem.reference_currency_id == 591) valuteName = '₺';
                if (this.detailedItem.reference_currency_id == 906) valuteName = '֏';
                if (this.detailedItem.reference_currency_id == 908) valuteName = 'د.إ';
            } else {
                itogSum = this.detailedItem.sum * this.detailedItem.turning / 100;
            }
            return `Вознаграждение ${itogSum.toFixed(2)} ${valuteName}`;
        },
    }
}
</script>
